import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { REQUEST_VIEWS } from "@/features/booking/modules/requests/request-views";
import { m } from "@/paraglide/messages.js";

/** Requests are a tab of the notifications page now. Old links (emails, bookmarks) land on it. */
export const Route = createFileRoute("/(private)/booking/requests/")({
  loader: () => ({ crumb: m.booking_requests_page_title() }),
  validateSearch: z.object({ bookingId: z.string().optional(), view: z.enum(REQUEST_VIEWS).optional() }),
  beforeLoad: ({ search }) => {
    throw redirect({
      to: "/notifications",
      search: { tab: "requests", view: search.view, bookingId: search.bookingId },
      replace: true,
    });
  },
});
